import { Icon } from '@toggle/design-system';
import React, { InputHTMLAttributes } from 'react';

import styles from './SearchInput.module.scss';
import * as S from './SearchInput.styles';

export interface SearchInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  onClear(): void;
  showClearButton?: boolean;
}

export const SearchInput = ({
  onClear,
  showClearButton = false,
  ref,
  className,
  ...rest
}: SearchInputProps & { ref?: React.Ref<HTMLInputElement> }) => {
  return (
    <S.SearchInputRoot className={className}>
      <S.InputContainer>
        <S.SearchIcon>
          <Icon iconName="Search" size={24} />
        </S.SearchIcon>

        <input
          ref={ref}
          className={styles.input}
          data-testid="search-input"
          type="text"
          autoComplete="off"
          spellCheck={false}
          {...rest}
        />

        {showClearButton && (
          <S.ClearButton
            type="button"
            data-testid="clear-button"
            onClick={onClear}
          >
            <Icon iconName="CloseFillCircle" size={20} />
          </S.ClearButton>
        )}
      </S.InputContainer>
    </S.SearchInputRoot>
  );
};
